import { compose } from '@hive/util'
import { ClipboardEventHandler } from 'react'

// TODO: Maybe it should be configurable?
const PHONE_LENGTH = 11

/**
 * Clean the phone number - remove all non-digit characters
 */
const cleanPhone = (phone: string) => {
  return phone.replace(/\D/g, '')
}

/**
 * Get the phone number body without country code
 * Example: 79123456789 -> 9123456789
 */
const extractPhoneBody = (phone: string) => {
  if (phone.length === PHONE_LENGTH && /^[87]/.test(phone)) {
    return phone.slice(1)
  }
  return phone
}

/**
 * Returns only phone number body without country code
 * Example: +7 912 345 67 89 -> 9123456789
 * Example: 79123456789 -> 9123456789
 */
export const getPhoneBody = compose(extractPhoneBody, cleanPhone)

/**
 * Handler for phone number paste - remove 1 digit if the number starts with 7/8
 * Example: 89123456789 -> 9123456789
 */
export const handlePhonePaste: ClipboardEventHandler = (e) => {
  e.preventDefault()

  const target = e.target as HTMLInputElement | HTMLTextAreaElement | null

  if (target && typeof target.selectionStart === 'number') {
    const pasted = e.clipboardData?.getData('text') || ''

    const phoneBody = getPhoneBody(pasted)

    const start = target.selectionStart
    const end = target.selectionEnd
    const value = target.value

    const newValue = value.slice(0, start) + phoneBody + value.slice(end as number)
    target.value = newValue

    const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      'value',
    )?.set
    nativeInputValueSetter?.call(target, newValue)

    const event = new Event('input', { bubbles: true })
    target.dispatchEvent(event)
  }
}